import React, { useState } from 'react';

import moment, { Moment } from 'moment';
import { useHistory, useLocation } from 'react-router';
import smartlookClient from 'smartlook-client';

import { useMediaQuery, useTheme } from '@material-ui/core';

import { ProductTelemetryController } from '../product-telemetry/product-telemetry-controller';
import { UiBreadcrumbHeader } from '../ui/ui-breadcrumb-header';
import * as WebRoutes from '../web-routes';
import { HOME_ROUTE } from '../web-routes';

import { EventCalendarBody } from './event-calendar-body';

import { CalendarDisplayType } from './utils/calendar-display-type';
import { isProd } from '../config/config';

type InputProps = {
  orgId: number;
  calendarDisplay: ValueOf<typeof CalendarDisplayType>;
};

type Props = InputProps;

export const EventCalendarPage = (props: Props) => {
  const { orgId, calendarDisplay } = props;

  const [calendarStart, setCalendarStart] = useState<Moment>(moment());

  const history = useHistory();
  const theme = useTheme();
  const onMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const { pathname, state: locationState } = useLocation();
  const { previousLocationPath } = (locationState || {}) as { previousLocationPath: string };
  const onFullCalendarView = pathname.includes(WebRoutes.eventCalendarRoute(orgId));

  const handleRouteToFullView = () => {
    if (isProd && smartlookClient) {
      smartlookClient.track('Click to Full Calendar View', { source: 'Dashboard Schedule' });
    }

    ProductTelemetryController.logEvent('full calendar link clicked');

    history.push(WebRoutes.eventCalendarRoute(orgId));
  };

  return (
    <div>
      <UiBreadcrumbHeader pageTitle="Calendar" backToPage={previousLocationPath || HOME_ROUTE} />
      <div
        className={`card ${
          calendarDisplay === CalendarDisplayType.PARTIAL_WEEK
            ? 'u-margin-x u-margin-bottom-xl'
            : 'u-margin-lg'
        }`}
      >
        <div
          className={`card-head u-display-flex ${
            calendarDisplay === CalendarDisplayType.MONTH
              ? 'u-justifyContent-center'
              : 'u-justifyContent-spaceBetween'
          }`}
        >
          <div className="typo-h6 u-display-flex">
            {calendarDisplay === CalendarDisplayType.MONTH
              ? calendarStart.format('MMMM YYYY')
              : 'Schedule'}
          </div>
          {!onFullCalendarView && !onMobile ? (
            <div
              onClick={handleRouteToFullView}
              className="typo-link u-display-flex u-alignSelf-flexEnd"
              role="presentation"
            >
              View Monthly Schedule
            </div>
          ) : null}
        </div>
        <EventCalendarBody
          orgId={orgId}
          calendarDisplay={calendarDisplay}
          calendarStart={calendarStart}
          setCalendarStart={setCalendarStart}
        />
      </div>
    </div>
  );
};
